<template>
	<Notification :notification="notification" class="notificationNewData">
		<template #title>{{ t('notification.newDataTitle') }}</template>

		<template #body>
			<div class="text-ink-60">
				{{ t('notification.newDataBodyA') }}
			</div>
			<div class="whitespace-nowrap text-ink-60">
				{{ t('notification.newDataBodyB') }}
				<span class="font-bold">{{ remaining }}</span>
				{{ t('notification.newDataBodyC') }}
			</div>
		</template>

		<template #actions>
			<Button size="s" @click="reload">{{ t('notification.newDataLoadNow') }}</Button>
		</template>
	</Notification>
</template>

<script setup lang="ts">
import { Button, Notification, useTranslation } from '@bluebrick/saas-ui'
import { useCountdown } from '@vueuse/core'
import { onBeforeUnmount, onMounted } from 'vue'
import { NewDataNotificationId, type LocalNotificationItem } from '@/features/notifications/types'
import { useNotificationsStore } from '@/features/notifications/useNotificationsStore'
import { useTelemetry } from '@/features/telemetry/useTelemetry'

const secondsToAutoReload = 30

const { t } = useTranslation()
const { trackEvent } = useTelemetry()
const { remove } = useNotificationsStore()

const props = defineProps<{
	notification: LocalNotificationItem
}>()

const emit = defineEmits<{
	action: [name: string, payload?: unknown]
}>()

const { remaining, stop, start } = useCountdown(secondsToAutoReload, {
	onComplete() {
		reload(true)
	}
})

onMounted(() => {
	start()
})

onBeforeUnmount(() => {
	stop()
})

function reload(isTimerAction?: boolean) {
	if (!isTimerAction) {
		trackEvent('user', 'Clicked "load now" button in new data notification.')
	}

	stop()

	emit('action', NewDataNotificationId)

	remove(props.notification)
}
</script>
